import { PaymentMethodType } from './schema/payment-method.js'

export const ASSET_TYPES = {
  __proto__: null,
  crypto: 'crypto',
  fiat: 'fiat',
}

export const ORDER_TYPES = {
  __proto__: null,
  buy: 'buy',
  sell: 'sell',
}

export const PROVIDERS = {
  __proto__: null,
  blockchain: 'blockchain',
  moonpay: 'moonpay',
  onramper: 'onramper',
  paypal: 'paypal',
  ramp: 'ramp',
  robinhood: 'robinhood',
  sardine: 'sardine',
  xopay: 'xopay',
}

export const SIDES = {
  __proto__: null,
  from: 'from',
  to: 'to',
}

export const PAYMENT_METHOD_TYPES = {
  __proto__: null,
  ...PaymentMethodType.schema,
}

export const ORDER_EVENT_TYPES = {
  __proto__: null,
  error: 'client_error',
  info: 'client_info',
}

export const FILTER_LIST_MODES = {
  __proto__: null,
  blacklist: 'blacklist',
  whitelist: 'whitelist',
}

export const ORDER_PAYMENT_METHODS = {
  __proto__: null,
  APPLE_PAY: 'APPLE_PAY',
  AUTO_BANK_TRANSFER: 'AUTO_BANK_TRANSFER',
  CARD_PAYMENT: 'CARD_PAYMENT',
  GOOGLE_PAY: 'GOOGLE_PAY',
  MANUAL_BANK_TRANSFER: 'MANUAL_BANK_TRANSFER',
}
